import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  RegisteredNameField,
  TrustTypeSelectComponent,
  TrustNumberField,
  OneColumn,
  MenuItemsForDropDown,
} from "@soqs/common";
import { useSelector } from "react-redux";
import {
  dropdownopts,
  dropdownsloading,
  trusttype,
} from "../../features/AppSlice";
import MastersOfficeSelect from "./usercomponents/MasterOfficeSelect";
import { useForm } from "react-final-form";

const TrustDetails = () => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);
  const trustType = useSelector(trusttype);

  const masterOfficeOptionsKey =
    trustType === 4 ? "mastersofficeCIS" : "mastersoffice";

  const [disableMO, setDisableMO] = useState(false);

  const form = useForm();

  useEffect(() => {
    if (trustType === 4) {
      setDisableMO(true);
      form.change("mastersOffice", 0);
    } else {
      if (form.getFieldState("mastersOffice").value === 0) {
        form.change("mastersOffice", undefined);
      }
      setDisableMO(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trustType]);

  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardHeader title="Trust Details" />
        <CardContent>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            <OneColumn>
              <RegisteredNameField required={true} />
            </OneColumn>
            <OneColumn>
              <TrustTypeSelectComponent
                trustTypes={MenuItemsForDropDown(
                  "trusttype",
                  dropdownoptions,
                  true
                )}
                optionsloading={dropdownloading}
              />
            </OneColumn>
            <OneColumn>
              <TrustNumberField required={true} />
            </OneColumn>
            <OneColumn>
              <MastersOfficeSelect
                mastersOffices={MenuItemsForDropDown(
                  masterOfficeOptionsKey,
                  dropdownoptions,
                  true
                )}
                optionsloading={dropdownloading}
                disabled={disableMO}
                required={!disableMO}
              />
            </OneColumn>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TrustDetails;
